import { ONE_HOUR_MS } from '../../constant'

/** *****************************************************************************
 * Provides additional utilities for date time
 */

/**
 * @param testDate Date timestamp (long) in UTC
 * @param expireHours Hours until expiration
 * @return True if the date has past the expiration hours
 */
export const isExpired = (
  testDate: Date | string,
  expireHours: number
): boolean => {
  const todayMs = (new Date()).getTime()
  const dateMs = (new Date(testDate)).getTime()
  const expireMs = expireHours * ONE_HOUR_MS
  return (todayMs - dateMs) > expireMs
}

/**
 * @param date1 Date string parse-able by Date()
 * @param date2 Date string parse-able by Date()
 * @return true if dates are same year, false if not
 */
export const isSameYear = (
  date1: string | number,
  date2: string | number
): boolean => {
  if ( date1 && date2 ) {
    const d1 = new Date(date1)
    const d2 = new Date(date2)
    return d1.getFullYear() === d2.getFullYear()
  } else {
    return false
  }
}

// Example: Wednesday, July 16, 2025 at 12:35 PM EDT
export const formatLongDateTime = (
  inputDate: Date | number,
  timeZone: string
) => {
  // Custom options for more detailed formatting
  const optionsDate: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }
  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    // second: '2-digit',
    timeZoneName: 'short',
    timeZone
  }
  const partDate = new Intl.DateTimeFormat('en-US', optionsDate).format(inputDate)
  const partTime = new Intl.DateTimeFormat('en-US', optionsTime).format(inputDate)
  const trimmedTime = partTime.startsWith('0') ? partTime.substring(1) : partTime
  return `${partDate  } ${  trimmedTime}`
}
